var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-outgoing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dark",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 2.45703C12.1875 2.14637 12.4393 1.89453 12.75 1.89453H14.25C15.3891 1.89453 16.3125 2.81794 16.3125 3.95703V5.45703C16.3125 5.76769 16.0607 6.01953 15.75 6.01953C15.4393 6.01953 15.1875 5.76769 15.1875 5.45703V3.95703C15.1875 3.91199 15.1843 3.86769 15.1782 3.82434L11.6477 7.35478C11.4281 7.57445 11.0719 7.57445 10.8523 7.35478C10.6326 7.13511 10.6326 6.77895 10.8523 6.55928L14.3827 3.02885C14.3393 3.02271 14.295 3.01953 14.25 3.01953H12.75C12.4393 3.01953 12.1875 2.76769 12.1875 2.45703Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M15.75 14.457V13.2226C15.75 12.6092 15.3766 12.0577 14.8071 11.8299L13.2815 11.2196C12.5571 10.9299 11.7316 11.2437 11.3828 11.9415L11.25 12.207C11.25 12.207 9.375 11.832 7.875 10.332C6.375 8.83203 6 6.95703 6 6.95703L6.26551 6.82428C6.96328 6.47539 7.27714 5.64988 6.98741 4.92555L6.37717 3.39995C6.14937 2.83046 5.59781 2.45703 4.98445 2.45703H3.75C2.92157 2.45703 2.25 3.1286 2.25 3.95703C2.25 10.5844 7.62258 15.957 14.25 15.957C15.0784 15.957 15.75 15.2855 15.75 14.457Z",
    fill: "#6B47F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutgoing);
export default __webpack_public_path__ + "static/media/call-outgoing.29d885a3028008b61918ed5428020dbf.svg";
export { ForwardRef as ReactComponent };